import { render, staticRenderFns } from "./statusOpenvpn.vue?vue&type=template&id=21e1a38c"
import script from "./statusOpenvpn.vue?vue&type=script&lang=js"
export * from "./statusOpenvpn.vue?vue&type=script&lang=js"
import style0 from "./statusOpenvpn.vue?vue&type=style&index=0&id=21e1a38c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VDataTable,VDivider,VIcon,VProgressCircular})
